import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=7a663a23&scoped=true&"
import script from "./QuestionCard.vue?vue&type=script&lang=js&"
export * from "./QuestionCard.vue?vue&type=script&lang=js&"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=7a663a23&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a663a23",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VBtn,VCard,VCardText,VCardTitle,VIcon,VTextarea})
